/** Standalone GMS parts-search styles for hosts without Tailwind (e.g. OrCA Place Enquiry). */
export const GMS_PARTS_SEARCH_CSS = `
.garaaz-parts-search-gms {
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  --background: oklch(0.99 0.005 240);
  --foreground: oklch(0.18 0.04 250);
  --card: oklch(1 0 0);
  --muted: oklch(0.96 0.008 250);
  --muted-foreground: oklch(0.5 0.02 255);
  --border: oklch(0.92 0.01 250);
  --input: oklch(0.92 0.01 250);
  --ring: oklch(0.5 0.18 260);
  color: var(--foreground);
}
.garaaz-parts-search-gms .relative { position: relative; }
.garaaz-parts-search-gms .absolute { position: absolute; }
.garaaz-parts-search-gms .inset-y-0 { top: 0; bottom: 0; }
.garaaz-parts-search-gms .left-3 { left: 0.75rem; }
.garaaz-parts-search-gms .left-9 { left: 2.25rem; }
.garaaz-parts-search-gms .right-3 { right: 0.75rem; }
.garaaz-parts-search-gms .top-1\\/2 { top: 50%; }
.garaaz-parts-search-gms .-translate-y-1\\/2 { transform: translateY(-50%); }
.garaaz-parts-search-gms .z-10 { z-index: 10; }
.garaaz-parts-search-gms .pointer-events-none { pointer-events: none; }
.garaaz-parts-search-gms .block { display: block; }
.garaaz-parts-search-gms .flex { display: flex; }
.garaaz-parts-search-gms .h-5 { height: 1.25rem; }
.garaaz-parts-search-gms .h-11 { height: 2.75rem; }
.garaaz-parts-search-gms .w-full { width: 100%; }
.garaaz-parts-search-gms .min-w-0 { min-width: 0; }
.garaaz-parts-search-gms .flex-1 { flex: 1 1 0%; }
.garaaz-parts-search-gms .shrink-0 { flex-shrink: 0; }
.garaaz-parts-search-gms .items-center { align-items: center; }
.garaaz-parts-search-gms .gap-2 { gap: 0.5rem; }
.garaaz-parts-search-gms .gap-x-3 { column-gap: 0.75rem; }
.garaaz-parts-search-gms .gap-y-0\\.5 { row-gap: 0.125rem; }
.garaaz-parts-search-gms .space-y-0 > * + * { margin-top: 0; }
.garaaz-parts-search-gms .space-y-1\\.5 > * + * { margin-top: 0.375rem; }
.garaaz-parts-search-gms .space-y-2 > * + * { margin-top: 0.5rem; }
.garaaz-parts-search-gms .overflow-hidden { overflow: hidden; }
.garaaz-parts-search-gms .overflow-y-auto { overflow-y: auto; }
.garaaz-parts-search-gms .overscroll-contain { overscroll-behavior: contain; }
.garaaz-parts-search-gms .truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.garaaz-parts-search-gms .rounded-md { border-radius: 0.375rem; }
.garaaz-parts-search-gms .rounded-xl { border-radius: 0.75rem; }
.garaaz-parts-search-gms .border { border-width: 1px; border-style: solid; border-color: var(--border); }
.garaaz-parts-search-gms .border-input { border-color: var(--input); }
.garaaz-parts-search-gms .border-border\\/80 { border-color: oklch(0.92 0.01 250 / 0.8); }
.garaaz-parts-search-gms .bg-background { background-color: var(--background); }
.garaaz-parts-search-gms .bg-card { background-color: var(--card); }
.garaaz-parts-search-gms .bg-muted\\/10 { background-color: oklch(0.96 0.008 250 / 0.1); }
.garaaz-parts-search-gms .bg-muted\\/30 { background-color: oklch(0.96 0.008 250 / 0.3); }
.garaaz-parts-search-gms .bg-muted\\/40 { background-color: oklch(0.96 0.008 250 / 0.4); }
.garaaz-parts-search-gms .bg-yellow-200 { background-color: #fef08a; }
.garaaz-parts-search-gms .p-2 { padding: 0.5rem; }
.garaaz-parts-search-gms .p-3 { padding: 0.75rem; }
.garaaz-parts-search-gms .px-0 { padding-left: 0; padding-right: 0; }
.garaaz-parts-search-gms .px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.garaaz-parts-search-gms .py-1\\.5 { padding-top: 0.375rem; padding-bottom: 0.375rem; }
.garaaz-parts-search-gms .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.garaaz-parts-search-gms .pl-9 { padding-left: 2.25rem; }
.garaaz-parts-search-gms .pr-3 { padding-right: 0.75rem; }
.garaaz-parts-search-gms .mt-1\\.5 { margin-top: 0.375rem; }
.garaaz-parts-search-gms .mt-2 { margin-top: 0.5rem; }
.garaaz-parts-search-gms .ml-1 { margin-left: 0.25rem; }
.garaaz-parts-search-gms .text-left { text-align: left; }
.garaaz-parts-search-gms .text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.garaaz-parts-search-gms .text-xs { font-size: 0.75rem; line-height: 1rem; }
.garaaz-parts-search-gms .font-medium { font-weight: 500; }
.garaaz-parts-search-gms .font-semibold { font-weight: 600; }
.garaaz-parts-search-gms .leading-snug { line-height: 1.375; }
.garaaz-parts-search-gms .leading-inherit { line-height: inherit; }
.garaaz-parts-search-gms .tabular-nums { font-variant-numeric: tabular-nums; }
.garaaz-parts-search-gms .text-muted-foreground { color: var(--muted-foreground); }
.garaaz-parts-search-gms .inline { display: inline; }
.garaaz-parts-search-gms .shadow-xs { box-shadow: 0 1px 2px 0 oklch(0.2 0.04 260 / 0.04); }
.garaaz-parts-search-gms .shadow-sm { box-shadow: 0 1px 2px 0 oklch(0.2 0.04 260 / 0.04); }
.garaaz-parts-search-gms .transition-colors { transition: color 0.15s, background-color 0.15s, border-color 0.15s; }
.garaaz-parts-search-gms .transition-all { transition: all 0.5s ease-in-out; }
.garaaz-parts-search-gms .duration-500 { transition-duration: 500ms; }
.garaaz-parts-search-gms .ease-in-out { transition-timing-function: ease-in-out; }
.garaaz-parts-search-gms .opacity-0 { opacity: 0; }
.garaaz-parts-search-gms .opacity-100 { opacity: 1; }
.garaaz-parts-search-gms .translate-y-0 { transform: translateY(0); }
.garaaz-parts-search-gms .translate-y-full { transform: translateY(100%); }
.garaaz-parts-search-gms .-translate-y-full { transform: translateY(-100%); }
.garaaz-parts-search-gms .max-h-72 { max-height: 18rem; }
.garaaz-parts-search-gms .flex-wrap { flex-wrap: wrap; }
.garaaz-parts-search-gms .size-4 { width: 1rem; height: 1rem; }
.garaaz-parts-search-gms .animate-pulse { animation: garaaz-gms-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
.garaaz-parts-search-gms .animate-spin { animation: garaaz-gms-spin 1s linear infinite; }
.garaaz-parts-search-gms input[type="text"] {
  display: flex;
  width: 100%;
  height: 2.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--input);
  background: var(--background);
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--foreground);
  box-shadow: 0 1px 2px 0 oklch(0.2 0.04 260 / 0.04);
  outline: none;
}
.garaaz-parts-search-gms input[type="text"]:focus-visible {
  box-shadow: 0 0 0 1px var(--ring);
}
.garaaz-parts-search-gms button[type="button"] {
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-align: left;
}
@keyframes garaaz-gms-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
@keyframes garaaz-gms-spin { to { transform: rotate(360deg); } }
`;

export function injectGmsPartsSearchStyles(): void {
  if (typeof document === "undefined") return;
  const id = "garaaz-gms-parts-search-styles";
  if (document.getElementById(id)) return;
  const el = document.createElement("style");
  el.id = id;
  el.textContent = GMS_PARTS_SEARCH_CSS;
  document.head.appendChild(el);
}
